export default __webpack_public_path__ + "static/media/apvs-site.3e029088.webp";